import useTableFilters from "@/hooks/useTableFilters";
import SelectStatus from "components/select/status";
import ProjectCombobox from "components/directus/combobox/project";
import JobCombobox from "components/directus/combobox/job";
import TypeFilter from "components/job/type/filter";
import { FilterActions } from "components/filter/actions";
import FiltersList from "components/filter/list";
import { Label } from "ui/components/label";

export default function MilestonesFilters({
  filters,
  setFilters,
  setIsOpen,
  isOpen,
  defaultFilters,
  clearFilters,
}) {
  const {
    localFilters,
    applyFilters,
    clearLocalFilters,
    handleSetLocalFilters,
  } = useTableFilters({
    filters,
    setFilters,
    setIsOpen,
    clearFilters,
    initialFilters: {
      status: undefined,
      job: undefined,
      ...defaultFilters,
    },
    defaultFilters,
  });

  return (
    <FiltersList>
      {/* Project */}
      <div>
        <Label className="mb-2 text-sm">Project</Label>
        <ProjectCombobox
          value={localFilters.job?.project?._eq}
          className="w-full"
          placeholder="Select"
          hideLabel
          searchPlaceholder="Search Project..."
          dependsOn={isOpen}
          onChange={(selectedItem) =>
            handleSetLocalFilters({
              job: {
                ...localFilters?.job,
                project: { ...localFilters.job?.project, _eq: selectedItem },
              },
            })
          }
        />
      </div>

      {/* Job */}
      <div>
        <Label className="mb-2 text-sm">Job</Label>
        <JobCombobox
          value={localFilters.job?._eq}
          className="w-full"
          placeholder="Select"
          searchPlaceholder="Search Job..."
          hideLabel
          dependsOn={isOpen}
          onChange={(selectedItem) =>
            handleSetLocalFilters({
              job: {
                ...localFilters?.job,
                _eq: selectedItem,
              },
            })
          }
        />
      </div>

      {/* Job Type (type lives on the job, not the milestone) */}
      <div>
        <Label className="mb-2 text-sm">Type</Label>
        <TypeFilter
          value={localFilters.job?.type?._eq}
          onChange={(selectedItem) => {
            const { type: _type, ...restJob } = localFilters?.job || {};
            handleSetLocalFilters({
              job: selectedItem
                ? { ...restJob, type: { _eq: selectedItem } }
                : Object.keys(restJob).length
                  ? restJob
                  : undefined,
            });
          }}
        />
      </div>

      {/* Status */}
      <div>
        <Label className="mb-2 text-sm">Status</Label>
        <SelectStatus
          collection="milestones"
          value={localFilters?.status?._eq}
          onChange={(selectedItem) =>
            handleSetLocalFilters({
              status: selectedItem ? { _eq: selectedItem } : undefined,
            })
          }
        />
      </div>

      <FilterActions
        applyFilters={applyFilters}
        clearLocalFilters={clearLocalFilters}
      />
    </FiltersList>
  );
}
